var t, s;
function e() {
  if (s) return t;
  s = 1;
  return t = class {
    constructor(t, s, e, r, a) {
      this.smartyKey = t, this.include = s, this.exclude = e, this.dataset = r, this.dataSubset = a, this.response = {}, this.customParameters = {};
    }
    addCustomParameter(t, s) {
      this.customParameters[t] = s;
    }
  };
}
export { e as __require };